export default __webpack_public_path__ + "static/media/WEX_OTR_LOGOS.47f4d998.svg";